import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919310771976" // replace with your number
      className="whatsapp-button"
      target="_blank"
      rel="noreferrer"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
